import styled from 'styled-components';

export const StyledAlertText = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledCircle = styled.span`
    height: 12px;
    width: 12px;
    background-color: ${props => (props.enabled ? 'green' : '#bbb')} ;
    border-radius: 50%;
    display: inline-block;
`;
